// extracted by mini-css-extract-plugin
export default {"comment":"style_comment__THU3h","commentHeader":"style_commentHeader__d8KmP","commentFooter":"style_commentFooter__38PE-","date":"style_date__EIWHi"};